const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? '/api'

export interface ApiError {
  status: number
  code: string
  message: string
}

function authHeader(): Record<string, string> {
  if (typeof window === 'undefined') return {}
  const token = window.localStorage.getItem('avt:jwt')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      ...(init?.headers ?? {}),
    },
    credentials: 'include',
  })
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as Partial<ApiError>
    throw {
      status: res.status,
      code: body.code ?? 'unknown',
      message: body.message ?? res.statusText,
    } satisfies ApiError
  }
  return (await res.json()) as T
}
